module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_18.ba870565.png";